import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';

import { checkChecklistCondition } from '../../../../InspectionUtils';
import styles from './InspectionFieldsContainer.module.scss';
import inspectionStyles from '../checklist.module.scss';

const InspectionFieldsContainer = ({
  checklist,
  activeIdx,
  handleInspectionFieldChanged,
  answers,
  answer,
  translations,
  isColumn,
  groups,
  inspection
}) => {
  const filterGroupsForChecklist = checklistIds => groups?.filter(group => group?.fields?.some(field => checklistIds.includes(field)));
  const checklistIds = checklist?.map(item => item.id);
  const filterdGroups = filterGroupsForChecklist(checklistIds);
  return (
  <div className={styles.inspectionFieldsContainer}>
    {filterdGroups && filterdGroups.length > 0 ? (
      <>
        {filterdGroups.map(grp => (
          <div className={styles.inspectionFields}>
            <span className={styles.title}>
              {grp.title}
            </span>
            <table>
              <thead>
                <tr className={styles.tableHead}>
                  <th>
                    <FormattedMessage id="inspections.complete_inspections.status" defaultMessage="Status" />
                  </th>
                  <th>
                    <FormattedMessage id="inspections.complete_inspections.facilities" defaultMessage="Facilities" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {checklist.map((inspectionField, idx) => {
                  let inspectionFieldStyle = inspectionStyles.untouched;
                  const checklist_length = Object.keys(inspectionField.checklist.filter(
                    item => checkChecklistCondition(item, answers)
                  )).length;
                  let allAnswers = answers[inspectionField.id] && (
                    checklist_length === Object.keys(
                      answers[inspectionField.id]
                    ).length);
                  if (answer && !allAnswers) {
                    const response = {};
                    inspectionField.checklist.forEach((item) => {
                      if (
                        checkChecklistCondition(item, answers)
                        && answers?.[inspectionField.id]?.[item.key] !== undefined
                      ) {
                        response[item.key] = answers[inspectionField.id][item.key];
                      }
                    });
                    allAnswers = response && (
                      checklist_length === Object.keys(
                        response
                      ).length);
                  }
                  if (allAnswers && answers[inspectionField.id]) {
                    let allTrue = Object.values(answers[inspectionField.id]);
                    if (isColumn) {
                      const result = allTrue.map(f => !Object.values(f).includes(false));
                      allTrue = !result.includes(false);
                    } else if (allTrue && allTrue.length > 0) {
                      allTrue = allTrue.reduce((a, b) => a && b);
                    }
                    inspectionFieldStyle = allTrue ? inspectionStyles.success : inspectionStyles.failure;
                    } else if (idx === activeIdx && inspection?.default_satisfactory && !inspection?.tolerance_inspection) {
                      inspectionFieldStyle = inspectionStyles.success;
                  }
                  let field = '';
                  const groupCheckList = grp.fields.filter(fieldId => fieldId === inspectionField.id);
                  if (groupCheckList.length > 0 && checklist_length > 0) {
                    field = (
                      <tr
                        role="button"
                        tabIndex="0"
                        key={inspectionField.id}
                        onClick={() => { handleInspectionFieldChanged(idx); }}
                        onKeyPress={() => { handleInspectionFieldChanged(idx); }}
                      >
                        <td className={styles.status}>
                          <span className={`${inspectionStyles.statusDot} ${inspectionFieldStyle}`} />
                        </td>
                        <td className={`${styles.tableData} ${idx === activeIdx ? styles.active : ''}`}>
                          {(translations && translations[inspectionField.title]) || inspectionField.title}
                        </td>
                      </tr>
                    );
                  }
                  return (
                    <React.Fragment key={inspectionField.id}>{field}</React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </>
    ) : (
      <div className={styles.inspectionFields}>
        <span className={styles.title}>
          <FormattedMessage id="inspections.complete_inspections.summary" defaultMessage="" />
        </span>
        <table>
          <thead>
            <tr className={styles.tableHead}>
              <th>
                <FormattedMessage id="inspections.complete_inspections.status" defaultMessage="Status" />
              </th>
              <th>
                <FormattedMessage id="inspections.complete_inspections.facilities" defaultMessage="Facilities" />
              </th>
            </tr>
          </thead>
          <tbody>
            {checklist.map((inspectionField, idx) => {
              let inspectionFieldStyle = inspectionStyles.untouched;
              const checklist_length = Object.keys(inspectionField.checklist.filter(
                item => checkChecklistCondition(item, answers)
              )).length;
              const allAnswers = answers[inspectionField.id] && (
                checklist_length === Object.keys(
                  answers[inspectionField.id]
                ).length);
              if (allAnswers) {
                let allTrue = Object.values(answers[inspectionField.id]);
                if (isColumn) {
                  const result = allTrue.map(f => !Object.values(f).includes(false));
                  allTrue = !result.includes(false);
                } else if (allTrue && allTrue.length > 0) allTrue = allTrue.reduce((a, b) => a && b);
                inspectionFieldStyle = allTrue ? inspectionStyles.success : inspectionStyles.failure;
                } else if (idx === activeIdx && inspection?.default_satisfactory && !inspection?.tolerance_inspection) {
                  inspectionFieldStyle = inspectionStyles.success;
              }
              let field = '';
              if (checklist_length > 0) {
                field = (
                  <tr
                    role="button"
                    tabIndex="0"
                    key={inspectionField.id}
                    onClick={() => { handleInspectionFieldChanged(idx); }}
                    onKeyPress={() => { handleInspectionFieldChanged(idx); }}
                  >
                    <td className={styles.status}>
                      <span className={`${inspectionStyles.statusDot} ${inspectionFieldStyle}`} />
                    </td>
                    <td className={`${styles.tableData} ${idx === activeIdx ? styles.active : ''}`}>
                      {(translations && translations[inspectionField.title]) || inspectionField.title}
                    </td>
                  </tr>
                );
              }
              return (
                <React.Fragment key={inspectionField.id}>{field}</React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
  </div>
);
};

InspectionFieldsContainer.propTypes = {
  checklist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeIdx: PropTypes.number.isRequired,
  shiftName: PropTypes.string.isRequired,
  answers: PropTypes.shape({}).isRequired,
  handleInspectionFieldChanged: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  answer: PropTypes.shape({}),
  translations: PropTypes.shape({}),
  isColumn: PropTypes.bool,
  groups: PropTypes.arrayOf(PropTypes.shape({})),
  inspection: PropTypes.shape({})
};
InspectionFieldsContainer.defaultProps = {
  answer: {},
  translations: {},
  isColumn: false,
  groups: [],
  inspection: {}
};
export default InspectionFieldsContainer;
